import Config from '../../../../config';

const rows = {
    cs: [
        {
            links: [
                {
                    id: 'about-us',
                    link: Config.routes['/about-us'],
                    messageId: 'footer.column.ackee.link.about',
                },
                {
                    id: 'career',
                    link: Config.routes['/career'],
                    messageId: 'footer.column.ackee.link.career',
                },
                {
                    id: 'prague',
                    link: Config.routes['/contact/prague'],
                    messageId: 'footer.column.ackee.link.prague',
                },
            ],
        },
        {
            links: [
                {
                    id: 'berlin',
                    link: Config.routes['/contact/berlin'],
                    messageId: 'footer.column.ackee.link.berlin',
                },
                {
                    id: 'blog',
                    link: Config.routes['/blog'],
                    messageId: 'footer.column.ackee.link.blog',
                },
                {
                    id: 'whitepaper',
                    link: 'common.links.whitepaper',
                    messageId: 'footer.column.ackee.link.whitepaper',
                    blank: true,
                },
            ],
        },
    ],
    en: [
        {
            links: [
                {
                    id: 'about-us',
                    link: Config.routes['/about-us'],
                    messageId: 'footer.column.ackee.link.about',
                },
                {
                    id: 'career',
                    link: Config.routes['/career'],
                    messageId: 'footer.column.ackee.link.career',
                },
                {
                    id: 'prague',
                    link: Config.routes['/contact/prague'],
                    messageId: 'footer.column.ackee.link.prague',
                },
            ],
        },
        {
            links: [
                {
                    id: 'berlin',
                    link: Config.routes['/contact/berlin'],
                    messageId: 'footer.column.ackee.link.berlin',
                },
                {
                    id: 'blog',
                    link: Config.routes['/blog'],
                    messageId: 'footer.column.ackee.link.blog',
                },
                {
                    id: 'whitepaper',
                    link: 'common.links.whitepaper',
                    messageId: 'footer.column.ackee.link.whitepaper',
                    blank: true,
                },
            ],
        },
    ],
    de: [
        {
            links: [
                {
                    id: 'about-us',
                    link: Config.routes['/about-us'],
                    messageId: 'footer.column.ackee.link.about',
                },
                {
                    id: 'prague',
                    link: Config.routes['/contact/prague'],
                    messageId: 'footer.column.ackee.link.prague',
                },
            ],
        },
        {
            links: [
                {
                    id: 'berlin',
                    link: Config.routes['/contact/berlin'],
                    messageId: 'footer.column.ackee.link.berlin',
                },
                {
                    id: 'blog',
                    link: Config.routes['/blog'],
                    messageId: 'footer.column.ackee.link.blog',
                },
                {
                    id: 'whitepaper',
                    link: 'common.links.whitepaper',
                    messageId: 'footer.column.ackee.link.whitepaper',
                    blank: true,
                },
            ],
        },
    ],
};

export const content = {
    ackee: {
        title: 'footer.column.ackee.title',
        rows: rows[Config.env.LANG_ENV],
    },
    services: {
        title: 'footer.column.services.title',
        rows: [
            {
                links: [
                    {
                        id: 'design',
                        link: Config.routes['/designPage'],
                        messageId: 'footer.column.services.link.design',
                    },
                ],
            },
            {
                links: [
                    {
                        id: 'appDevelopment',
                        link: Config.routes['/app-development'],
                        messageId: 'footer.column.services.link.appDevelopment',
                    },
                ],
            },
            {
                links: [
                    {
                        id: 'appDevelopmentMobile',
                        link: Config.routes['/app-development'],
                        anchor: '#mobile',
                        messageId: 'footer.column.services.link.appDevelopmentMobile',
                    },
                ],
            },
            {
                links: [
                    {
                        id: 'appDevelopmentWeb',
                        link: Config.routes['/app-development'],
                        anchor: '#web',
                        messageId: 'footer.column.services.link.appDevelopmentWeb',
                    },
                ],
            },
            {
                links: [
                    {
                        id: 'blockchain',
                        link: 'common.links.blockchain',
                        messageId: 'footer.column.services.link.blockchain',
                    },
                ],
            },
        ],
    },
};
